<template>
  <div id="coldWalletSetting" class="clearfix mg_bot50">
    <div class="clearfix box-head">
      <span class="title_item">{{
        $t("cold_wallet_setting.receive_title")
      }}</span>
    </div>
    <div class="clearfix box-content">
      <div
        class="wallet-setting"
        v-for="(item, index) in dataModel.cold_wallet"
      >
        <div class="clearfix row-item col-50">
          <!-- <label class="row-item-label" v-if="item.currency === 'omni.2'">{{ $t('cold_wallet_setting.usdt_address') }}</label>
                    <label class="row-item-label mw" v-else>{{ $t('cold_wallet_setting.address', { currency: item.coin.toUpperCase() }) }}</label> -->
          <label class="row-item-label mw">{{
            getCoinNetworkName(item.coin)
          }}</label>
          <div class="row-item-value">
            <input
              @change="inputHandle(item)"
              v-model="item.address"
              :maxlength="maxLength"
              @click="commonHandle"
              :disabled="checkEditable(item.currency)"
              :class="{ 'input-error': errors.has(item.currency + '_address') }"
            />
            <div class="error-box">
              <span
                v-show="errors.has(item.currency + '_address')"
                class="f-left is-error"
                >{{ errors.first(item.currency + "_address") }}</span
              >
            </div>
          </div>
        </div>
        <!--                <div class="clearfix row-item col-25">-->
        <!--                    <label class="row-item-label">{{ $t('cold_wallet_setting.min_balance') }}</label>-->
        <!--                    <div class="row-item-value" @click="commonHandle">-->
        <!--                        <currency-input v-model="item.lowerThreshold" :maxLengthCus="maxLengthInput" :precision="8" :disabled="!editable" :class="{'input-error': errors.has(item.coin + '_min_balance')}"/>-->
        <!--                        &lt;!&ndash; <input-only-number v-model="item.lowerThreshold" :disabled="!editable" :class="{'input-error': errors.has(item.coin + '_min_balance')}" /> &ndash;&gt;-->
        <!--                        <div class="error-box">-->
        <!--                            <span v-show="errors.has(item.coin + '_min_balance')" class="f-left is-error">{{ errors.first(item.coin + '_min_balance') }}</span>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="clearfix row-item col-25">-->
        <!--                    <label class="row-item-label">{{ $t('cold_wallet_setting.max_balance') }}</label>-->
        <!--                    <div class="row-item-value" @click="commonHandle">-->
        <!--                        <currency-input v-model="item.upperThreshold" :maxLengthCus="maxLengthInput" :precision="8" :disabled="!editable" :class="{'input-error': errors.has(item.coin + '_max_balance')}"/>-->
        <!--                        &lt;!&ndash; <input-only-number v-model="item.upperThreshold" :disabled="!editable" :class="{'input-error': errors.has(item.coin + '_max_balance')}" /> &ndash;&gt;-->
        <!--                        <div class="error-box">-->
        <!--                            <span v-show="errors.has(item.coin + '_max_balance')" class="f-left is-error">{{ errors.first(item.coin + '_max_balance') }}</span>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>
    </div>
    <div class="clearfix box-head">
      <span class="title_item">{{
        $t("cold_wallet_setting.notification_title")
      }}</span>
    </div>
    <div class="clearfix box-content">
      <div class="clearfix row-item col-75">
        <label class="row-item-label">{{
          $t("cold_wallet_setting.holder_email")
        }}</label>
        <div class="row-item-value">
          <input
            type="text"
            v-model="dataModel.cold_wallet_holder_email"
            :maxlength="maxLengthEmail"
            autocomplete="off"
            readonly
            @focus="$event.target.removeAttribute('readonly')"
            @click="commonHandle"
            @blur="trimEmail"
            :disabled="!editable"
            :class="{ 'input-error': errors.has('cold_wallet_holder_email') }"
            data-vv-validate-on="none"
            v-validate="{
              required: true,
              regex: /^\w+([\.-]?\w+)+@\w+([\.:]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/,
              maxLength: 15,
            }"
          />
          <div class="error-box">
            <span
              v-show="errors.has('cold_wallet_holder_email')"
              class="f-left is-error"
              >{{ errors.first("cold_wallet_holder_email") }}</span
            >
          </div>
        </div>
      </div>
      <!--            <div class="clearfix row-item col-75">-->
      <!--                <label class="row-item-label">{{ $t('cold_wallet_setting.holder_name') }}</label>-->
      <!--                <div class="row-item-value">-->
      <!--                    <input type="text" v-model="dataModel.cold_wallet_holder_name" :maxlength="maxLength" @click="commonHandle" :disabled="!editable" :class="{'input-error': errors.has('cold_wallet_holder_name')}"/>-->
      <!--                    <div class="error-box">-->
      <!--                        <span v-show="errors.has('cold_wallet_holder_name')" class="f-left is-error">{{ errors.first('cold_wallet_holder_name') }}</span>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--            <div class="clearfix row-item col-75">-->
      <!--                <label class="row-item-label">{{ $t('cold_wallet_setting.holder_mobile') }}</label>-->
      <!--                <div class="row-item-value">-->
      <!--                    <input type="text" v-model="dataModel.cold_wallet_holder_mobile_no" :maxlength="maxLength" @click="commonHandle" v-validate="{ required: true, regex: /^\+(?:[0-9] ?){6,14}[0-9]$/ }" data-vv-validate-on="none" :disabled="!editable" :class="{'input-error': errors.has('cold_wallet_holder_mobile_no')}"/>-->
      <!--                    <div class="error-box">-->
      <!--                        <span v-show="errors.has('cold_wallet_holder_mobile_no')" class="f-left is-error">{{ errors.first('cold_wallet_holder_mobile_no') }}</span>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
    </div>
    <div class="clearfix tool-action">
      <BaseButton v-if="!editable" @click="edit">
        {{ $t("common.action.edit") }}
      </BaseButton>
      <BaseButton v-if="editable" @click="cancel">
        {{ $t("common.action.return") }}
      </BaseButton>
      <BaseButton v-if="editable" @click="saveData">
        {{ $t("common.action.save") }}
      </BaseButton>
    </div>
    <loading-modal />
  </div>
</template>

<script>
import rf from "../../lib/RequestFactory";
import InputOnlyNumber from "../../common/InputOnlyNumber";
import CONST from "../../common/Const";
import CurrencyInput from "../../components/CurrencyInput";
import LoadingModal from "@/modals/common/LoadingModal.vue";
import BaseButton from "@/common/Button.vue";
export default {
  components: {
    InputOnlyNumber,
    CurrencyInput,
    LoadingModal,
    BaseButton,
  },
  data() {
    return {
      titlePage: this.$t("cold_wallet_setting.title_page"),
      editable: false,
      dataModel: {
        cold_wallet: [],
        cold_wallet_holder_email: null,
        cold_wallet_holder_name: null,
        cold_wallet_holder_mobile_no: null,
      },
      updateAddress: [],
      updateMail: [],
      maxLength: CONST.MAX_LENGTH_INPUT,
      maxLengthInput: 21,
      maxLengthEmail: 100,
    };
  },
  methods: {
    getCoinNetworkName(coin) {
      if (!coin) return "";

      const networkMap = {
        btc: "Bitcoin",
        eth: "Ethereum",
        bnb: "BNB Smart Chain",
        bsc: "BNB Smart Chain",
        sol: "Solana",
        matic: "Polygon",
        polygon: "Polygon",
        trx: "Tron",
        tron: "Tron",
        usdt: "USDT",
        usdc: "USDC",
      };

      const coinLower = coin.toLowerCase();
      return networkMap[coinLower] || coin.toUpperCase();
    },
    async inputHandle(item) {
      let res = await rf.getRequest("AdminRequest").getColdWallets();
      const coldWalletData = res.data || res;

      if (item.currency === CONST.CURRENCY_ETH) {
        for (let key in this.dataModel.cold_wallet) {
          if (
            this.dataModel.cold_wallet[key].currency.substring(0, 5) ===
            CONST.CURRENCY_TOKEN
          ) {
            this.dataModel.cold_wallet[key].address = item.address;
          }
        }
      }

      if (coldWalletData[item.coin] !== undefined) {
        const oldAddress = coldWalletData[item.coin];
        const newAddress = item.address;

        const existingIndex = this.updateAddress.findIndex(
          (a) => a.coin === item.coin.toUpperCase()
        );

        if (oldAddress === newAddress) {
          if (existingIndex >= 0) {
            this.updateAddress.splice(existingIndex, 1);
          }
        } else {
          const addressChange = {
            coin: item.coin.toUpperCase(),
            oldAddress: oldAddress,
            newAddress: newAddress,
          };

          if (existingIndex >= 0) {
            this.updateAddress[existingIndex] = addressChange;
          } else {
            this.updateAddress.push(addressChange);
          }
        }
      }
    },
    checkEditable(currency) {
      if (!CONST.LIST_COIN.includes(currency)) return true;
      return !this.editable;
    },
    async loadData() {
      this.$modal.show("modal-loading");
      try {
        const res = await rf.getRequest("AdminRequest").getColdWallets();

        const resColdWalletSetting = await rf
          .getRequest("AdminRequest")
          .getColdWalletSetting();
        const coldWalletData = res.data || res;

        this.dataModel.cold_wallet = Object.keys(coldWalletData).map(
          (coin) => ({
            coin: coin,
            currency: coin,
            address: coldWalletData[coin] || "",
          })
        );

        this.dataModel.cold_wallet_holder_email = resColdWalletSetting.value;
      } catch (error) {
        if (!error.response) {
          this.$toastr("error", this.$t("common.message.network_error"));
          return;
        }
      } finally {
        this.$modal.hide("modal-loading");
      }
    },
    edit() {
      this.editable = !this.editable;
    },
    cancel() {
      this.editable = !this.editable;
      this.errors.clear();
      this.updateAddress = [];
      this.updateMail = [];
      this.loadData();
    },
    formatEmail(email) {
      if (!email) return email;

      const trimmedEmail = email.trim();
      if (!trimmedEmail) return trimmedEmail;

      return trimmedEmail.toLowerCase();
    },
    async saveData() {
      this.$modal.show("modal-loading");

      // Format email before validation
      if (this.dataModel.cold_wallet_holder_email) {
        this.dataModel.cold_wallet_holder_email = this.formatEmail(
          this.dataModel.cold_wallet_holder_email
        );
      }

      let validateResult = await this.validate();

      if (!validateResult) {
        this.$modal.hide("modal-loading");
        return;
      }

      if (validateResult) {
        try {
          let res = await rf.getRequest("AdminRequest").getColdWalletSetting();
          const oldEmail = res.value;
          const newEmail = this.dataModel.cold_wallet_holder_email;

          const isEmailExist = oldEmail && oldEmail.trim() !== "";
          const isEmailChanged = oldEmail !== newEmail;

          await rf.getRequest("AdminRequest").updateColdWalletSetting({
            coldWalletEmail: newEmail,
          });

          if (!isEmailExist) {
            const hasAddressChanges = this.updateAddress.length > 0;

            if (hasAddressChanges || isEmailChanged) {
              if (isEmailChanged) {
                this.updateMail.push({
                  oldEmail: oldEmail,
                  newEmail: newEmail,
                });
              }

              await rf.getRequest("AdminRequest").sendMailUpdateColdWallet({
                changedAddress: this.updateAddress,
                changedEmail: this.updateMail,
              });

              // Reset
              this.updateAddress = [];
              this.updateMail = [];
            }
          } else {
            this.updateAddress = [];
            this.updateMail = [];
          }

          this.$modal.hide("modal-loading");
          this.editable = false;
          this.$toastr("success", this.$t("common.alert.update.success"));
        } catch (error) {
          this.$modal.hide("modal-loading");
          if (!error.response) {
            this.$toastr("error", this.$t("common.message.network_error"));
            return;
          }

          // Handle API validation error for coldWalletEmail
          if (error.response.data && error.response.data.message) {
            const messages = error.response.data.message;
            if (Array.isArray(messages)) {
              messages.forEach((msg) => {
                if (msg.includes("coldWalletEmail must be an email")) {
                  this.$validator.errors.add({
                    field: "cold_wallet_holder_email",
                    msg: "This email address is invalid.",
                  });
                }
              });
            }
          }

          // Handle old error format
          const errors = error.response.data.errors;
          if (errors) {
            this.validateErrors = errors;

            window._.each(this.validateErrors, (value, key) => {
              if (key !== "cold_wallet") {
                this.$validator.errors.add({ field: key, msg: value[0] });
              } else {
                let arrErr = JSON.parse("[" + value[0] + "]");
                for (var i = 0; i < arrErr.length; i++) {
                  let item = arrErr[i];
                  for (var property in item) {
                    this.$validator.errors.add({
                      field: property,
                      msg: item[property][0],
                    });
                  }
                }
              }
            });
          }
        }
      }
    },
    async validate() {
      this.errors.clear();

      if (!this.dataModel.cold_wallet_holder_email) {
        this.$validator.errors.add({
          field: "cold_wallet_holder_email",
          msg: this.$t("cold_wallet_setting.holder_email.invalid"),
        });
      }
      const contact_mail = this.dataModel.cold_wallet_holder_email
        ? this.dataModel.cold_wallet_holder_email
        : "";
      const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (contact_mail && !regexEmail.test(String(contact_mail))) {
        this.errors.add({
          field: "cold_wallet_holder_email",
          msg: this.$t("cold_wallet_setting.holder_email_format.invalid"),
        });
      }
      return this.$validator.errors.items.length <= 0;
    },

    async format(coin) {
      try {
        let data = await rf.getRequest("ValidateRequest").formatCurrency(coin);
        return data.toUpperCase();
      } catch (error) {
        this.$toastr("error", error);
        return;
      }
    },
    commonHandle() {
      this.errors.clear();
    },
    trimEmail() {
      if (this.dataModel.cold_wallet_holder_email) {
        this.dataModel.cold_wallet_holder_email =
          this.dataModel.cold_wallet_holder_email.trim();
      }
    },
  },
  mounted() {
    this.$emit("EVENT_PAGE_CHANGE", this);
    this.loadData();
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";
.is-error {
  display: inline-block;
  line-height: 20px;
  padding-top: 5px;
}
.is-error {
  color: $color-denim !important;
}
.input-error {
  border: 1px solid $color-denim !important;
}
.f-left {
  float: left;
}
.error-box {
  display: block;
  float: left;
  overflow: hidden;
  width: 100%;
  span {
    font-family: $mulish-regular !important;
  }
}
.wallet-setting {
  float: left;
  width: 100%;
}
.box-head {
  padding: 15px 0px;
  .title_item {
    font-size: $font_big;
    line-height: normal;
  }
}
.box-content {
  padding: 20px 15px;
  border: 1px solid $color_alto;
  margin-bottom: 30px;
  float: left;
  width: 100%;
  .row-item {
    margin-bottom: 10px;
    .row-item-label {
      font-family: $mulish-regular;
      font-size: $font-small;
      font-weight: normal;
      line-height: 35px;
      margin: 0;
    }
    .row-item-value {
      float: right;
      input {
        border-radius: 3px;
        border: solid 1px $color_alto;
        background-color: $color-white-smoke;
        height: 35px;
        padding: 8px 12px;
        width: 100%;
        &:focus {
          border-color: $color-jungle-green;
        }
        &.sub-address {
          margin-top: 5px;
          width: 50%;
        }
      }
    }
  }
}
.tool-action {
  float: left;
  display: flex;
  button {
    margin-right: 10px;
  }
}
.col-25 {
  float: left;
  width: 25%;
  .row-item-label {
    padding-right: 30px;
    width: 50%;
    text-align: right;
  }
  .row-item-value {
    width: 50%;
  }
}
.col-50 {
  float: left;
  width: 50%;
  .row-item-value {
    width: 70%;
  }
}
.col-75 {
  float: left;
  width: 75%;
  .row-item-value {
    width: 70%;
  }
}
input {
  &:disabled {
    background-color: $color-bright-gray !important;
  }
}
#coldWalletSetting {
  margin-bottom: 80px;
}
</style>
